import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';

import useSession from '../../hooks/useSession';
import loadingIcon from '../../utils/assets/loading_icon.svg';
import WarningIcon from '../../icons/WarningIcon';

import { useInspectorStyles } from './styles';

import Button from '@mui/material/Button';
import WaitingModalMessage from './WaitingModalMessage';
import {
  formatPhoneNumberToE164,
  formatPhoneNumberToNANPFormat,
} from '../../utils/helpers';

const WaitingModalContent = ({
  smsSendStatus,
  handleCloseWaitingModal,
  bookingId,
  mobileNumber,
}: {
  smsSendStatus: any;
  handleCloseWaitingModal: () => void;
  bookingId: string | undefined;
  mobileNumber: string;
}) => {
  const styles = useInspectorStyles();
  const { mediaStatus, setMediaStatus, pingMediaStatus, setPingMediaStatus } =
    useSession(bookingId);

  useEffect(() => {
    if (
      smsSendStatus?.status === 'success' ||
      smsSendStatus?.status === 'error'
    ) {
      setMediaStatus([]);
      setPingMediaStatus(150);
    }
    return () => {
      setPingMediaStatus(0);
    };
  }, [smsSendStatus]);

  console.log(
    '::::mobileNumber',
    mobileNumber,
    formatPhoneNumberToE164(mobileNumber.replace('+', '')),
  );

  return (
    <>
      {smsSendStatus?.status === 'error' ||
      (smsSendStatus?.status === 'success' && pingMediaStatus === 0) ? (
        <Box sx={{ width: '5rem', height: '5rem', mb: '1rem' }}>
          <WarningIcon />
        </Box>
      ) : (
        <Box sx={{ width: '5rem', height: '5rem', mb: '1rem' }}>
          <img
            style={{
              transform: `rotate(0deg)`,
              animation: 'rotate 2s linear infinite',
            }}
            src={loadingIcon}
            alt="loading icon"
          />
        </Box>
      )}

      <WaitingModalMessage
        mediaStatus={mediaStatus}
        key={smsSendStatus?.status}
        mobileNumber={formatPhoneNumberToNANPFormat(mobileNumber)}
      />

      <Button
        onClick={() => {
          setPingMediaStatus(0);
          handleCloseWaitingModal();
        }}
        sx={styles.moreOptions}>
        End call attempt
      </Button>
    </>
  );
};

export default WaitingModalContent;
